@import "../../../../globalStyles/commons";

:host {
  display: block;
  height: 100%;
}

.header-brand {
  display: flex;
  align-items: center;
  height: 100%;
  padding-inline-start: v(--spacing-04);
  padding-inline-end: v(--spacing-04);

  .brand-link {
    height: 100%;
    display: flex;
    align-items: center;
    --goat-button-height: 100%;
    --goat-button-border-radius: 0;
    --goat-button-padding: 0;
    --goat-button-color-hover: white;
  }

  .brand {
    display: flex;
    align-items: center;
    gap: v(--spacing-03);
    height: 100%;
    padding: 0 v(--spacing-02);
    @include font-style(heading-compact-01);
    font-size: 1rem;
  }

  .logo {
    height: var(--header-brand-logo-height, 2rem);
  }

  .subtitle-divider {
    height: 1.5rem;
  }

  .subtitle {
    padding: 0 v(--spacing-02);
  }


}


/*
 * Colors
 */
.header-brand {
  color: var(--header-brand-title-color);

  .subtitle {
    color: var(--header-brand-subtitle-color);
  }

  .subtitle-divider {
    --goat-divider-color: var(--header-brand-subtitle-color);
  }
}

:host-context(goat-header[color-is="dark"]):host {
  --header-brand-title-color: #{v(--color-white)};
  --header-brand-subtitle-color: #{v(--color-gray-30)};
}

:host-context(goat-header[color-is="light"]):host {
  --header-brand-title-color: #{v(--color-black)};
  --header-brand-subtitle-color: #{v(--color-gray-70)};
}

@include for-phone-only {
  .header-brand {
    padding-inline-start: v(--spacing-04);
  }
}
